import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './ToggleSwitchPanel.module.scss';

const ToggleSwitchPanel = ({ children }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="ToggleSwitchPanel"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      {children}
    </div>
  );
};

export default ToggleSwitchPanel;
